import { UnifiedDialogEntry } from '../../../../types';

type CreateOptimisticSMSParams = {
  text: string;
  toPhone: string;
  fromPhone: string;
  publicPhoneLabel?: string;
  mediaUrls?: string[];
  carrier?: string | null;
};

type CreateOptimisticEmailParams = {
  subject: string;
  body: string;
  toEmail: string;
  fromEmail: string;
  fromName?: string;
};

type CreateOptimisticNoteParams = {
  text: string;
  createdBy: string;
};

export const createOptimisticSMS = ({
  text,
  toPhone,
  fromPhone,
  publicPhoneLabel,
  mediaUrls = [],
  carrier = null,
}: CreateOptimisticSMSParams): UnifiedDialogEntry => {
  const optimisticId = `optimistic-sms-${Date.now()}-${Math.random()}`;

  return {
    entry_type: 'sms',
    entry_id: null,
    created_at: new Date().toISOString(),
    direction: 'outbound',
    from_phone: fromPhone,
    to_phone: toPhone,
    public_phone_number: fromPhone,
    public_phone_label: publicPhoneLabel,
    text,
    media_urls: mediaUrls,
    carrier,
    status: 'sending',
    optimistic: true,
    optimisticId,
  };
};

export const createOptimisticEmail = ({
  subject,
  body,
  toEmail,
  fromEmail,
  fromName,
}: CreateOptimisticEmailParams): UnifiedDialogEntry => {
  const optimisticId = `optimistic-email-${Date.now()}-${Math.random()}`;

  return {
    entry_type: 'email',
    entry_id: null,
    created_at: new Date().toISOString(),
    direction: 'outbound',
    from_email: fromEmail,
    to_email: toEmail,
    email_subject: subject,
    text: body,
    created_by: fromName,
    status: 'sending',
    optimistic: true,
    optimisticId,
  };
};

export const createOptimisticInternalNote = ({
  text,
  createdBy,
}: CreateOptimisticNoteParams): UnifiedDialogEntry => {
  const optimisticId = `optimistic-note-${Date.now()}-${Math.random()}`;

  return {
    entry_type: 'internal_note',
    entry_id: null,
    created_at: new Date().toISOString(),
    direction: 'outbound',
    text,
    created_by: createdBy,
    is_system_generated: false,
    status: 'sending',
    optimistic: true,
    optimisticId,
  };
};
